
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"5 5 31 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 24.5A8.75 8.75 0 1021 7a8.75 8.75 0 000 17.5z","stroke":"#1BBAC8","stroke-width":"3","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M7 33.25c1.419-2.66 3.46-4.87 5.917-6.405C15.374 25.309 18.162 24.5 21 24.5s5.626.809 8.083 2.345C31.541 28.38 33.581 30.59 35 33.25","stroke":"#1BBAC8","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    